import {ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {LookupService} from '../../services/lookup.service';
import {NaePipe} from '../../pipes/nae.pipe';
import {OrderPipe} from '../../pipes/order.pipe';
import * as _ from 'lodash';


@Component({
    selector: 'app-search-tree',
    templateUrl: './search-tree.component.html',
    styleUrls: ['./search-tree.component.scss'],
    providers: [NaePipe]
})
export class SearchTreeComponent implements OnInit, OnChanges {
    @Input() vehicleIdentification;
    @Input() registrationMonth: number;
    @Input() registrationYear: number;
    @Input() engineType: string;
    @Input() powerInKw: number;
    @Input() filter: string;
    @Output() resultChange = new EventEmitter();

    public makes = [];
    public mainTypes = [];
    public subTypes = [];
    private mainType: any;
    private subType: any;

    public notFoundText = 'Keine Ergebnisse';


    constructor(private lookupService: LookupService, private naePipe: NaePipe, private orderPipe: OrderPipe,
                private cd: ChangeDetectorRef) {
    }

    ngOnInit() {
        this.updateMakes();
    }

    updateMakes() {
        setTimeout(() => {
            this.lookupService.getMakes(this.filter).then((data) => {
                this.makes = [];
                for (const make of data) {
                    const obj = {value: make, display: make.makeName};
                    this.makes.push(obj);
                }
                this.resolveManufacturer();
                this.cd.markForCheck();

            });
        });
    }

    updateMainTypes() {
        setTimeout(() => {
            this.mainTypes = [];
            if (this.vehicleIdentification.mainType) {
                this.mainType = _.cloneDeep(this.vehicleIdentification.mainType);
            }

            this.vehicleIdentification.mainType = null;
            this.subTypes = [];
            if (this.vehicleIdentification.subType) {
                this.subType = _.cloneDeep(this.vehicleIdentification.subType);
            }
            this.vehicleIdentification.subType = null;
            if (!this.vehicleIdentification.manufacturer) {
                return;
            }

            this.lookupService.getMainTypes(this.vehicleIdentification.manufacturer.makeCode, this.filter)
                .then((data) => {
                    for (const mainType of data) {
                        const obj = {value: mainType, display: mainType.searchSeries};
                        this.mainTypes.push(obj);
                    }
                    // not needed, but the field shows 'no items found' if this line is removed
                    this.mainTypes = this.naePipe.transform(this.mainTypes);
                    if (this.vehicleIdentification && this.mainType) {
                        const obj = _.find(this.mainTypes,
                            ['value.searchSeriesCode', this.mainType.searchSeriesCode]);
                        if (obj) {
                            this.vehicleIdentification.mainType = obj.value;
                        } else {
                            this.vehicleIdentification.mainType = null;
                        }
                        this.cd.markForCheck();
                        this.updateSubTypes();
                    }

                });
        });

    }

    updateSubTypes() {
        setTimeout(() => {
            this.subTypes = [];

            if (this.vehicleIdentification.subType) {
                this.subType = _.cloneDeep(this.vehicleIdentification.subType);
            }
            this.vehicleIdentification.subType = null;
            if (!this.vehicleIdentification || !this.vehicleIdentification.manufacturer || !this.vehicleIdentification.mainType) {
                return;
            }

            this.lookupService.getSubTypes(this.vehicleIdentification.manufacturer.makeCode,
                this.vehicleIdentification.mainType.searchSeriesCode, this.filter)
                .then((data) => {
                    for (const subType of data) {
                        const display = subType.typeName + ' ' +
                            subType.equipment + ' ' +
                            subType.doorsCount + '-TÜRER ' +
                            subType.fuelType.description + ' ' +
                            subType.powerKW + ' KW ' +
                            subType.productionStartMonth + '.' +
                            subType.productionStartYear + ' - ' +
                            subType.productionEndMonth + '.' +
                            subType.productionEndYear;
                        this.subTypes.push({value: subType, display: display});
                    }
                    this.subTypes = this.applyTypeRestrictionFilter(this.subTypes);
                    if (this.vehicleIdentification && this.subType) {
                        const obj = _.find(this.subTypes,
                            ['value.schwackeCode', this.subType.schwackeCode]);
                        if (obj) {
                            this.vehicleIdentification.subType = obj.value;
                        }

                    }
                    this.cd.markForCheck();
                });
        });

    }

    clearMonthAndYear() {
        this.vehicleIdentification.registrationMonth = null;
        this.vehicleIdentification.registrationYear = null;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!changes.vehicleIdentification && (changes.registrationMonth
            || changes.registrationYear || changes.engineType || changes.powerInKw)) {
            this.updateSubTypes();
        }

        if (changes.vehicleIdentification) {
            if (this.makes.length === 0) {
                this.updateMakes();
            } else {
                this.resolveManufacturer();
            }

        }
    }

    private applyTypeRestrictionFilter(subTypes: any[]) {
        let res = this.applyProductionPeriodFilter(subTypes);

        res = this.applyEnginePowerFilter(res);
        res = this.applyEngineTypeFilter(res);
        return res;
    }

    private applyProductionPeriodFilter(subTypes: any[]) {
        return subTypes.filter(item => {
            if (!this.vehicleIdentification.registrationYear || !this.vehicleIdentification.registrationMonth) {
                return true;
            }
            const copy = _.cloneDeep(item.value);

            const startHash = String(copy.productionStartYear) + (parseInt(copy.productionStartMonth, 10) < 10 ? '0' : '')
                + String(copy.productionStartMonth);


            if (parseInt(copy.productionEndYear, 10) === 0) {
                copy.productionEndYear = new Date().getFullYear();
            }

            if (parseInt(copy.productionEndMonth, 10) === 0) {
                copy.productionEndMonth = (new Date().getMonth() + 2);
            }
            const endHash = String(copy.productionEndYear) + (parseInt(copy.productionEndMonth, 10) < 10 ? '0' : '') +
                String(copy.productionEndMonth);

            const ezHash = String(this.vehicleIdentification.registrationYear) +
                (parseInt(this.vehicleIdentification.registrationMonth, 10) < 10 ? '0' : '')
                + String(this.vehicleIdentification.registrationMonth);

            return parseInt(startHash, 10) <= parseInt(ezHash, 10) && parseInt(ezHash, 10) <= parseInt(endHash, 10);
        });
    }

    private applyEnginePowerFilter(res: any[]) {
        return res.filter(item => {
            if (this.vehicleIdentification.enginePower === undefined ||
                this.vehicleIdentification.enginePower === null ||
                this.vehicleIdentification.enginePower === '') {

                return true;
            }

            item = item.value;

            return item.powerKW.toString() === this.vehicleIdentification.enginePower.toString();
        });
    }

    private applyEngineTypeFilter(res: any[]) {
        return res.filter(item => {
            if (!this.vehicleIdentification.engineType ||
                this.vehicleIdentification.engineType === 'A') {
                return true;
            }

            item = item.value;

            const engineTypeMappings = {
                'D': ['D', 'X'],
                'B': ['A', 'G', 'H', 'N', 'P', 'S', 'T'],
                'H': ['H', 'X', 'Y', 'Z'],
                'E': ['E']
            };

            const map = engineTypeMappings[this.engineType];

            return map && map.indexOf(item.fuelType.code) !== -1;
        });

    }

    setSchwackeCode() {
        setTimeout(() => {
            if (this.vehicleIdentification.subType && this.vehicleIdentification.subType.schwackeCode) {
                this.vehicleIdentification.schwackeCode = this.vehicleIdentification.subType.schwackeCode;
            }
        });

    }

    compareManufacturer(a: any, b: any) {
        return a.value.makeCode === b.makeCode;
    }

    compareMainType(a: any, b: any) {
        return a.value.searchSeriesCode === b.searchSeriesCode;
    }

    compareSubType(a: any, b: any) {
        return a.value.schwackeCode === b.schwackeCode;
    }

    private resolveManufacturer() {
        if (this.vehicleIdentification && this.vehicleIdentification.manufacturer) {
            const obj = _.find(this.makes,
                ['value.makeCode', this.vehicleIdentification.manufacturer.makeCode]);
            if (obj) {
                this.vehicleIdentification.manufacturer = obj.value;
            }
            this.updateMainTypes();
        }
    }

    emitChangeEvent() {
        this.resultChange.emit();
    }
}
